let Typologies =
    [
        // FACADES CARDS

        //facades card for "Cw.U_1.5x4_U1.2_60.DGU_f.Al_c.Al"
        { 
            "id": "Rain_1.2x1.2_U1.2/0.2_15.wDGU_f.Al_c.Br",
            "name": "Brick facade option",
            "subtitle":"Double glazed, punch window",
            "type": "Buildings",
            "category": "Building Envelope",
            "subCategory": "Facade",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Brick",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Brick (general)" , "value": 41.57 },
                { "name": "Insulation - mineral wool" , "value": 0.43 },
                { "name": "Cement board" , "value": 4.79 },
                { "name": "Steel - glavanised" , "value": 26.76 },
                { "name": "Plasterboard" , "value": 16.86 },
                { "name": "steel - stainless" , "value": 14.68 },
                { "name": "Aluminium - extrusion" , "value": 14.85 },
                { "name": "Aluminium - sheet" , "value": 7.29 },
                { "name": "Glass (general)" , "value": 11.17 },

                
            ],
            "components": [
                { "name" : "Structure / Framing", "value": 56.28 },
                { "name": "Glazing", "value": 11.17 },
                { "name": "Cladding", "value": 70.51 },
                { "name": "Insulation", "value": 0.43 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 115.50 },
                {"name": "Transport (A4)", "value": 9.05 },
                {"name": "Wastage (A5)", "value": 13.86 },
            ],
            "totalCarbon": 138.40,
            "units": 'kgCO2/m2(facade area)',
            "description": "Brick facade option with aluminium frame. Double glazed, cavity wall unit. 4.5 x 4 (WxH) panel shown.",
            "designAssumptions": [
                { "name": "F2F height", "value": "4m"},
                { "name": "Typical dimensions", "value": "4.5m x 4m"},
                { "name": "U-value", "value": "1.2 W/m2K"},
                { "name": "Window size", "value": "1.8 x 1.2m"},
                { "name": "Cavity thickness", "value": "50mm"},
                { "name": "External insulation", "value": "80mm"},
                { "name": "DGU with glass piles", "value": "6.6"}          
            ],
            "references": [
                "CWCT Standard for Systemised Building Envelopers (2006)",
                "LETI design guidance for Thermal / Solar performance",
                "BCO Specifications (2019)"
            ],
            "src":require('@/store/typ-images/Rain_1.2x1.2_U1.2_15.wDGU_f.Al_c.Br.png'),
            "tags": ["facade","regionally sourced", "commercial office", "UK"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors": ["Fernando Ruiz", "Rosario Maguey Peña"]
        },
        
        //facades card for "Cw.U_1.5x4_U1.2_60.DGU_f.Al_c.Al"
        { 
            "id": "Cw.U_1.5x4_U1.2_60.DGU_f.Al_c.Al",
            "name": "Unitised Curtain Wall",
            "subtitle":"Double glazed, 60% vision area", 
            "type": "Buildings",
            "category": "Building Envelope",
            "subCategory": "Facade",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Aluminium",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Aluminium - extruded profile - European" , "value": 87.5 },
                { "name": "Aluminium - sheet - European" , "value": 43.8 },
                { "name": "Glass - glazing, Double" , "value": 56.9 },
                { "name": "Steel - hot dip galvanized" , "value": 11.1 },
                { "name": "Insulation - mineral wool" , "value": 4.0 },
                
            ],
            "components": [
                { "name" : "Structure / Framing", "value": 97.6 },
                { "name": "Glazing", "value": 56.9 },
                { "name": "Cladding", "value": 44.7 },
                { "name": "Insulation", "value": 4.1 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 186.5 },
                {"name": "Transport (A4)", "value": 1.9 },
                {"name": "Wastage (A5)", "value": 14.9 },
            ],
            "totalCarbon": 203.3,
            "units": 'kgCO2/m2(facade area)',
            "description": "Unitised curtain wall with aluminium framing, Double Glazed Units and insulated aluminium spandrel panels; 1.5x4 (WxH) panel size; 60% vision area.",
            "designAssumptions": [
                { "name": "F2F height", "value": "4m"},
                { "name": "Typical dimensions", "value": "1.5m x 4m"},
                { "name": "U-value", "value": "1.2 W/m2K"},
                { "name": "Window ratio", "value": "60%"},
                { "name": "Slab fire stop & smoke seal", "value": "EI120"},
                { "name": "Glass make-up", "value": "Annealed, 66.2 / Ar16 / 55.2"},
                { "name": "Cladding thickness", "value": "3mm"},
                { "name": "Wind loading", "value": "1 kPa"},
                { "name": "Deflection limit", "value": "as per CWCT"},
                { "name": "Wind resistance", "value": "as per CWCT"},
                { "name": "Water tightness", "value": "Class R7"},
                { "name": "Air Permeability", "value": "Class A4"},
                
            ],
            "references": [
                "CWCT Standard for Systemised Building Envelopers (2006)",
                "LETI design guidance for Thermal / Solar performance",
                "BCO Specifications (2019)"
            ],
            "src":require('@/store/typ-images/Cw-U_1-5x4_U1-2_60-DGU_f-Al_c-Al.png'),
            "tags": ["facade","regionally sourced", "unitised curtain wall", "commercial office", "UK"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors": ["Fernando Ruiz", "Rosario Maguey Peña"]
        },
        //facades card for "Cw.U_1.5x4_U1.2_45.DGU_f.Al_c.Al"
        { 
            "id": "Cw.U_1.5x4_U1.2_45.DGU_f.Al_c.Al",
            "name": "Unitised Curtain Wall", 
            "subtitle":"Double glazed, 45% vision area",
            "type": "Buildings",
            "category": "Building Envelope",
            "subCategory": "Facade",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Aluminium",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Aluminium - extruded profile - European" , "value": 97.7 },
                { "name": "Aluminium - sheet - European" , "value": 60.3 },
                { "name": "Glass - double glazing" , "value": 39.7 },
                { "name": "Steel - hot dip galvanised steel" , "value": 11.1 },
                { "name": "Insulation - mineral wool" , "value": 5.4 },
            ],
            "components": [  
                { "name": "Structure / Framing" , "value": 104.9 },
                { "name": "Glazing" , "value": 39.1 },
                { "name": "Cladding" , "value": 60.0 },
                { "name": "Insulation" , "value": 4.3 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 194.9 },
                {"name": "Transport (A4)", "value": 1.8 },
                {"name": "Wastage (A5)", "value": 17.6 },
            ],
            "totalCarbon": 214.3,
            "units": 'kgCO2/m2(facade area)',
            "description": "Unitised curtain wall with aluminium framing, Double Glazed Units and insulated aluminium spandrel panels; 1.5x4 (WxH) panel size; 45% vision area.",
            "designAssumptions": [
                { "name": "F2F height", "value": "4m"},
                { "name": "Typical dimensions", "value": "1.5m x 4m"},
                { "name": "U-value", "value": "1.2 W/m2K"},
                { "name": "Window ratio", "value": "45%"},
                { "name": "Slab fire stop & smoke seal", "value": "EI120"},
                { "name": "Glass make-up", "value": "Annealed, 55.2 / Ar16 / 44.2"},
                { "name": "Cladding thickness" , "value": "3mm" },
                { "name": "Wind loading" , "value": "1kPa" },
                { "name": "Deflection limit" , "value": "As per CWCT" },
                { "name": "Wind resistance" , "value": "As per CWCT" },
                { "name": "Water tightness" , "value": "Class R7" },
                { "name": "Air permeability" , "value": "Class A4" },
            ],
            "references": [
                "CWCT Standard for Systemised Building Envelopers (2006)",
                "LETI design guidance for Thermal / Solar performance",
                "BCO Specifications (2019)"
            ],
            "src":require('@/store/typ-images/Cw-U_1-5x4_U1-2_45-DGU_f-Al_c-Al.png'),
            "tags": ["facade","regionally sourced", "unitised curtain wall", "commercial office", "UK"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors": ["Fernando Ruiz", "Rosario Maguey Peña"]
        },
        //facades card for "Cw.U_1.5x4_U1.2_30.DGU_f.Al_c.Al"
        { 
            "id": "Cw.U_1.5x4_U1.2_30.DGU_f.Al_c.Al",
            "name": "Unitised Curtain Wall", 
            "subtitle":"Double glazed, 30% vision area",
            "type": "Buildings",
            "category": "Building Envelope",
            "subCategory": "Facade",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Aluminium",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Aluminium - extruded profile - European" , "value": 90.9 },
                { "name": "Aluminium - sheet - European" , "value": 77.3 },
                { "name": "Glass - double glazing" , "value": 27.6 },
                { "name": "Steel - hot dip galvanised steel" , "value": 11.1 },
                { "name": "Insulation - mineral wool" , "value": 7.1 },
            ],
            "components": [  
                { "name": "Structure / Framing" , "value": 102.7 },
                { "name": "Glazing" , "value": 27.8 },
                { "name": "Cladding" , "value": 77.0 },
                { "name": "Insulation" , "value": 6.5 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 193.7 },
                {"name": "Transport (A4)", "value": 1.6 },
                {"name": "Wastage (A5)", "value": 18.7 },
            ],
            "totalCarbon": 214.0,
            "units": 'kgCO2/m2(facade area)',
            "description": "Unitised curtain wall with aluminium framing, Double Glazed Units and insulated aluminium spandrel panels; 1.5x4 (WxH) panel size; 45% vision area.",
            "designAssumptions": [
                { "name": "F2F height", "value": "4m"},
                { "name": "Typical dimensions", "value": "1.5m x 4m"},
                { "name": "U-value", "value": "1.2 W/m2K"},
                { "name": "Window ratio", "value": "30%"},
                { "name": "Slab fire stop & smoke seal", "value": "EI120"},
                { "name": "Glass make-up", "value": "Annealed, 55.2 / Ar16 / 44.2"},
                { "name": "Cladding thickness" , "value": "3mm" },
                { "name": "Wind loading" , "value": "1kPa" },
                { "name": "Deflection limit" , "value": "As per CWCT" },
                { "name": "Wind resistance" , "value": "As per CWCT" },
                { "name": "Water tightness" , "value": "Class R7" },
                { "name": "Air permeability" , "value": "Class A4" },
            ],
            "references": [
                "CWCT Standard for Systemised Building Envelopers (2006)",
                "LETI design guidance for Thermal / Solar performance",
                "BCO Specifications (2019)"
            ],
            "src":require('@/store/typ-images/Cw-U_1-5x4_U1-2_30-DGU_f-Al_c-Al.png'),
            "tags": ["facade","regionally sourced", "unitised curtain wall", "commercial office", "UK"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors": ["Fernando Ruiz", "Rosario Maguey Peña"]
        },
        //facades card for "Cw-U_1-5x4_U1-2_60-DGU_f-Al_c-Sb"
        { 
            "id": "Cw.U_1.5x4_U1.2_60.DGU_f.Al_c.Sb",
            "name": "Unitised Curtain Wall",
            "subtitle":"Double glazed, shadow box, 60% vision area", 
            "type": "Buildings",
            "category": "Building Envelope",
            "subCategory": "Facade",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Aluminium",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Aluminium - extruded profile - European" , "value": 87.5 },
                { "name": "Aluminium - sheet - European" , "value": 41.0 },
                { "name": "Glass - double glazing" , "value": 91.4 },
                { "name": "Steel - hot dip galvanised steel" , "value": 11.1 },
                { "name": "Insulation - mineral wool" , "value": 4.0 },
            ],
            "components": [  
                { "name": "Structure / Framing" , "value": 98.7 },
                { "name": "Glazing" , "value": 91.65 },
                { "name": "Cladding" , "value": 40.0 },
                { "name": "Insulation" , "value": 4.7 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 217.4 },
                {"name": "Transport (A4)", "value": 2.7 },
                {"name": "Wastage (A5)", "value": 14.9 },
            ],
            "totalCarbon": 235.0,
            "units": 'kgCO2/m2(facade area)',
            "description": "Unitised curtain wall with aluminium framing, Double Glazed Units and insulated shadow box panels; 1.5x4 (WxH) panel size; 60% vision area.",
            "designAssumptions": [
                { "name": "F2F height", "value": "4m"},
                { "name": "Typical dimensions", "value": "1.5m x 4m"},
                { "name": "U-value", "value": "1.2 W/m2K"},
                { "name": "Window ratio", "value": "60%"},
                { "name": "Slab fire stop & smoke seal", "value": "EI120"},
                { "name": "Glass make-up", "value": "Annealed, 66.2 / Ar16 / 55.2"},
                { "name": "Cladding thickness" , "value": "3mm" },
                { "name": "Wind loading" , "value": "1kPa" },
                { "name": "Deflection limit" , "value": "As per CWCT" },
                { "name": "Wind resistance" , "value": "As per CWCT" },
                { "name": "Water tightness" , "value": "Class R7" },
                { "name": "Air permeability" , "value": "Class A4" },
            ],
            "references": [
                "CWCT Standard for Systemised Building Envelopers (2006)",
                "LETI design guidance for Thermal / Solar performance",
                "BCO Specifications (2019)"
            ],
            "src":require('@/store/typ-images/Cw-U_1-5x4_U1-2_60-DGU_f-Al_c-Sb.png'),
            "tags": ["facade","regionally sourced", "unitised curtain wall", "commercial office", "UK"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors": ["Fernando Ruiz", "Rosario Maguey Peña"]
        },
        //New card for Cw.U_1.5x4_U1.2_60.DGU_f.Al_c.Al_Fv.Al(400)
        { 
            "id": "Cw.U_1.5x4_U1.2_60.DGU_f.Al_c.Al_Fv.Al(400)",
            "name": "Unitised Curtain Wall", 
            "subtitle":"Double glazed, vertical fins, 60% vision area",
            "type": "Buildings",
            "category": "Building Envelope",
            "subCategory": "Facade",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Aluminium",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Aluminium - extruded profile - European" , "value": 129.8 },
                { "name": "Aluminium - sheet - European" , "value": 44.4 },
                { "name": "Glass - double glazing" , "value": 55.2 },
                { "name": "Steel - hot dip galvanised steel" , "value": 11.1 },
                { "name": "Insulation - mineral wool" , "value": 4.0 },
            ],
            "components": [  
                { "name": "Structure / Framing" , "value": 140.9 },
                { "name": "Glazing" , "value": 55.2 },
                { "name": "Cladding" , "value": 44.4 },
                { "name": "Insulation" , "value": 4.0 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 223.3 },
                {"name": "Transport (A4)", "value": 2.1 },
                {"name": "Wastage (A5)", "value": 19.2 },
            ],
            "totalCarbon": 244.6,
            "units": 'kgCO2/m2(facade area)',
            "description": "Unitised curtain wall with aluminium framing, Double Glazed Units, insulated aluminium spandrel panels and 400 mm deep vertical aluminium fins; 1.5x4 (WxH) panel size; 60% vision area.",
            "designAssumptions": [
                { "name": "F2F height", "value": "4m"},
                { "name": "Typical dimensions", "value": "1.5m x 4m"},
                { "name": "U-value", "value": "1.2 W/m2K"},
                { "name": "Window ratio", "value": "60%"},
                { "name": "Slab fire stop & smoke seal", "value": "EI120"},
                { "name": "Glass make-up", "value": "Annealed, 66.2 / Ar16 / 55.2"},
                { "name": "Cladding thickness" , "value": "3mm" },
                { "name": "Wind loading" , "value": "1kPa" },
                { "name": "Deflection limit" , "value": "As per CWCT" },
                { "name": "Wind resistance" , "value": "As per CWCT" },
                { "name": "Water tightness" , "value": "Class R7" },
                { "name": "Air permeability" , "value": "Class A4" },
            ],
            "references": [
                "CWCT Standard for Systemised Building Envelopers (2006)",
                "LETI design guidance for Thermal / Solar performance",
                "BCO Specifications (2019)"
            ],
            "src":require('@/store/typ-images/Cw-U_1-5x4_U1-2_60-DGU_f-Al_c-Al_Fv-Al(400).png'),
            "tags": ["facade","regionally sourced", "unitised curtain wall", "commercial office", "UK"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors": ["Fernando Ruiz", "Rosario Maguey Peña"]
        },
        //New card for Cw.U_1.5x4_U1.2_45.DGU_f.Al_c.Al_Fv.Al(400)
        { 
            "id": "Cw.U_1.5x4_U1.2_45.DGU_f.Al_c.Al_Fv.Al(400)",
            "name": "Unitised Curtain Wall",
            "subtitle":"Double glazed, vertical fins, 45% vision area", 
            "type": "Buildings",
            "category": "Building Envelope",
            "subCategory": "Facade",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Aluminium",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Aluminium - extruded profile - European" , "value": 139.9 },
                { "name": "Aluminium - sheet - European" , "value": 62.1 },
                { "name": "Glass - double glazing" , "value": 33.4 },
                { "name": "Steel - hot dip galvanised steel" , "value": 11.1 },
                { "name": "Insulation - mineral wool" , "value": 5.4 },
            ],
            "components": [  
                { "name": "Structure / Framing" , "value": 151.0 },
                { "name": "Glazing" , "value": 33.4 },
                { "name": "Cladding" , "value": 62.1 },
                { "name": "Insulation" , "value": 5.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 228.1 },
                {"name": "Transport (A4)", "value": 1.8 },
                {"name": "Wastage (A5)", "value": 21.9 },
            ],
            "totalCarbon": 251.9,
            "units": 'kgCO2/m2(facade area)',
            "description": "Unitised curtain wall with aluminium framing, Double Glazed Units, insulated aluminium spandrel panels and 400 mm deep vertical aluminium fins; 1.5x4 (WxH) panel size; 45% vision area.",
            "designAssumptions": [
                { "name": "F2F height", "value": "4m"},
                { "name": "Typical dimensions", "value": "1.5m x 4m"},
                { "name": "U-value", "value": "1.2 W/m2K"},
                { "name": "Window ratio", "value": "45%"},
                { "name": "Slab fire stop & smoke seal", "value": "EI120"},
                { "name": "Glass make-up", "value": "Annealed, 66.2 / Ar16 / 55.2"},
                { "name": "Cladding thickness" , "value": "3mm" },
                { "name": "Wind loading" , "value": "1kPa" },
                { "name": "Deflection limit" , "value": "As per CWCT" },
                { "name": "Wind resistance" , "value": "As per CWCT" },
                { "name": "Water tightness" , "value": "Class R7" },
                { "name": "Air permeability" , "value": "Class A4" },
            ],
            "references": [
                "CWCT Standard for Systemised Building Envelopers (2006)",
                "LETI design guidance for Thermal / Solar performance",
                "BCO Specifications (2019)"
            ],
            "src":require('@/store/typ-images/Cw-U_1-5x4_U1-2_45-DGU_f-Al_c-Al_Fv-Al(400).png'),
            "tags": ["facade","regionally sourced", "unitised curtain wall", "commercial office", "UK"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors": ["Fernando Ruiz", "Rosario Maguey Peña"]
        },
        //New card for Cw.U_1.5x4_U1.2_30.DGU_f.Al_c.Al_Fv.Al(400)
        { 
            "id": "Cw.U_1.5x4_U1.2_30.DGU_f.Al_c.Al_Fv.Al(400)",
            "name": "Unitised Curtain Wall",
            "subtitle":"Double glazed, vertical fins, 30% vision area",
            "type": "Buildings",
            "category": "Building Envelope",
            "subCategory": "Facade",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Aluminium",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Aluminium - extruded profile - European" , "value": 133.1 },
                { "name": "Aluminium - sheet - European" , "value": 80.2 },
                { "name": "Glass - double glazing" , "value": 22.2 },
                { "name": "Steel - hot dip galvanised steel" , "value": 11.1 },
                { "name": "Insulation - mineral wool" , "value": 7 },
            ],
            "components": [  
                { "name": "Structure / Framing" , "value": 144.2 },
                { "name": "Glazing" , "value": 22.2 },
                { "name": "Cladding" , "value": 80.2 },
                { "name": "Insulation" , "value": 7 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 228.9 },
                {"name": "Transport (A4)", "value": 1.7 },
                {"name": "Wastage (A5)", "value": 23.2 },
            ],
            "totalCarbon": 253.8,
            "units": 'kgCO2/m2(facade area)',
            "description": "Unitised curtain wall with aluminium framing, Double Glazed Units, insulated aluminium spandrel panels and 400 mm deep vertical aluminium fins; 1.5x4 (WxH) panel size; 30% vision area.",
            "designAssumptions": [
                { "name": "F2F height", "value": "4m"},
                { "name": "Typical dimensions", "value": "1.5m x 4m"},
                { "name": "U-value", "value": "1.2 W/m2K"},
                { "name": "Window ratio", "value": "30%"},
                { "name": "Slab fire stop & smoke seal", "value": "EI120"},
                { "name": "Glass make-up", "value": "Annealed, 66.2 / Ar16 / 55.2"},
                { "name": "Cladding thickness" , "value": "3mm" },
                { "name": "Wind loading" , "value": "1kPa" },
                { "name": "Deflection limit" , "value": "As per CWCT" },
                { "name": "Wind resistance" , "value": "As per CWCT" },
                { "name": "Water tightness" , "value": "Class R7" },
                { "name": "Air permeability" , "value": "Class A4" },
            ],
            "references": [
                "CWCT Standard for Systemised Building Envelopers (2006)",
                "LETI design guidance for Thermal / Solar performance",
                "BCO Specifications (2019)"
            ],
            "src":require('@/store/typ-images/Cw-U_1-5x4_U1-2_30-DGU_f-Al_c-Al_Fv-Al(400).png'),
            "tags": ["facade","regionally sourced", "unitised curtain wall", "commercial office", "UK"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors": ["Fernando Ruiz", "Rosario Maguey Peña"]
        },
        //New card for Cw-U_1-5x4_U1-2_45-DGU_f-Al_c-Sb
        { 
            "id": "Cw-U_1-5x4_U1-2_45-DGU_f-Al_c-Sb",
            "name": "Unitised Curtain Wall",
            "subtitle":"Double glazed, shadow box, 45% vision area", 
            "type": "Buildings",
            "category": "Building Envelope",
            "subCategory": "Facade",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Aluminium",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Aluminium - extruded profile - European" , "value": 97.5 },
                { "name": "Aluminium - sheet - European" , "value": 57.0 },
                { "name": "Glass - double glazing" , "value": 91.4 },
                { "name": "Steel - hot dip galvanised steel" , "value": 11.1 },
                { "name": "Insulation - mineral wool" , "value": 5.4 },
            ],
            "components": [  
                { "name": "Structure / Framing" , "value": 97.5 },
                { "name": "Glazing" , "value": 91.4 },
                { "name": "Cladding" , "value": 68.1 },
                { "name": "Insulation" , "value": 5.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 242.1 },
                {"name": "Transport (A4)", "value": 2.8 },
                {"name": "Wastage (A5)", "value": 17.8 },
            ],
            "totalCarbon": 262.7,
            "units": 'kgCO2/m2(facade area)',
            "description": "Unitised curtain wall with aluminium framing, Double Glazed Units and insulated shadow box panels; 1.5x4 (WxH) panel size; 45% vision area.",
            "designAssumptions": [
                { "name": "F2F height", "value": "4m"},
                { "name": "Typical dimensions", "value": "1.5m x 4m"},
                { "name": "U-value", "value": "1.2 W/m2K"},
                { "name": "Window ratio", "value": "45%"},
                { "name": "Slab fire stop & smoke seal", "value": "EI120"},
                { "name": "Glass make-up", "value": "Annealed, 55.2 / Ar16 / 44.2"},
                { "name": "Cladding thickness" , "value": "3mm" },
                { "name": "Wind loading" , "value": "1kPa" },
                { "name": "Deflection limit" , "value": "As per CWCT" },
                { "name": "Wind resistance" , "value": "As per CWCT" },
                { "name": "Water tightness" , "value": "Class R7" },
                { "name": "Air permeability" , "value": "Class A4" },
            ],
            "references": [
                "CWCT Standard for Systemised Building Envelopers (2006)",
                "LETI design guidance for Thermal / Solar performance",
                "BCO Specifications (2019)"
            ],
            "src":require('@/store/typ-images/Cw-U_1-5x4_U1-2_45-DGU_f-Al_c-Sb.png'),
            "tags": ["facade","regionally sourced", "unitised curtain wall", "commercial office", "UK"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors": ["Fernando Ruiz", "Rosario Maguey Peña"]
        },
        //New card for Cw-U_1-5x4_U1-2_30-DGU_f-Al_c-Sb
        { 
            "id": "Cw-U_1-5x4_U1-2_30-DGU_f-Al_c-Sb",
            "name": "Unitised Curtain Wall",
            "subtitle":"Double glazed, shadow box, 30% vision area", 
            "type": "Buildings",
            "category": "Building Envelope",
            "subCategory": "Facade",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Aluminium",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Aluminium - extruded profile - European" , "value": 90.9 },
                { "name": "Aluminium - sheet - European" , "value": 76.5 },
                { "name": "Glass - double glazing" , "value": 91.4 },
                { "name": "Steel - hot dip galvanised steel" , "value": 11.1 },
                { "name": "Insulation - mineral wool" , "value": 7.1 },
            ],
            "components": [  
                { "name": "Structure / Framing" , "value": 90.9 },
                { "name": "Glazing" , "value": 91.4 },
                { "name": "Cladding" , "value": 87.6 },
                { "name": "Insulation" , "value": 7.1 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 254.8 },
                {"name": "Transport (A4)", "value": 2.9 },
                {"name": "Wastage (A5)", "value": 19.32 },
            ],
            "totalCarbon": 277,
            "units": 'kgCO2/m2(facade area)',
            "description": "Unitised curtain wall with aluminium framing, Double Glazed Units and insulated shadow box panels; 1.5x4 (WxH) panel size; 30% vision area.",
            "designAssumptions": [
                { "name": "F2F height", "value": "4m"},
                { "name": "Typical dimensions", "value": "1.5m x 4m"},
                { "name": "U-value", "value": "1.2 W/m2K"},
                { "name": "Window ratio", "value": "30%"},
                { "name": "Slab fire stop & smoke seal", "value": "EI120"},
                { "name": "Glass make-up", "value": "Annealed, 55.2 / Ar16 / 44.2"},
                { "name": "Cladding thickness" , "value": "3mm" },
                { "name": "Wind loading" , "value": "1kPa" },
                { "name": "Deflection limit" , "value": "As per CWCT" },
                { "name": "Wind resistance" , "value": "As per CWCT" },
                { "name": "Water tightness" , "value": "Class R7" },
                { "name": "Air permeability" , "value": "Class A4" },
            ],
            "references": [
                "CWCT Standard for Systemised Building Envelopers (2006)",
                "LETI design guidance for Thermal / Solar performance",
                "BCO Specifications (2019)"
            ],
            "src":require('@/store/typ-images/Cw-U_1-5x4_U1-2_30-DGU_f-Al_c-Sb.png'),
            "tags": ["facade","regionally sourced", "unitised curtain wall", "commercial office", "UK"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors": ["Fernando Ruiz", "Rosario Maguey Peña"]
        },

        // STRUCTURES CARDS
        
        // Structures Frame - Frame_s5_b0_9x9_1_TTT
        { 
            "id": "Frame_s5_b0_9x9_1_TTT_UK",
            "name": "CLT timber 9x9",
            "subtitle":"up to 5 storeys", 
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Timber",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - Glulam" , "value": 30.8 },
                { "name": "Timber - CLT" , "value": 59.3 },
            ],
            "components": [  
                { "name": "Columns" , "value": 3.8 },
                { "name": "Beams" , "value": 27.0 },
                { "name": "Slab" , "value": 59.3 },
            ],
            "carbon": [
                {"name": "Sequestration (not included)" , "value": -166.9 },
                {"name": "Material creation (A1-3)","value": 65.8 },
                {"name": "Transport (A4)", "value": 24.3 },
                {"name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 90.1,
            "units": 'kgCO2/m2(floor area)',
            "description": "480mmx750mm(dp) primary beam nested within slab depth, 480mmx500mm(dp) secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Glulam grade", "value": "GL24"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "0-5"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s5_b0_9x9_1_TTT_UK.png'),
            "tags": ["Commercial office", "Timber", "CLT", "Baseline", "Glulam"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s15_b0_9x9_1_TTT
        { 
            "id": "Frame_s15_b0_9x9_1_TTT_UK",
            "name": "CLT timber 9x9", 
            "subtitle": "up to 15 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Timber",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - Glulam" , "value": 36.5 },
                { "name": "Timber - CLT" , "value": 59.3 },
            ],
            "components": [  
                { "name": "Columns" , "value": 9.5 },
                { "name": "Beams" , "value": 27.0 },
                { "name": "Slab" , "value": 59.3 },
            ],
            "carbon": [
                {"name": "Sequestration (not included)" , "value": -176.2 },
                {"name": "Material creation (A1-3)","value": 70.0 },
                {"name": "Transport (A4)", "value": 25.7 },
                {"name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 95.8,
            "units": 'kgCO2/m2(floor area)',
            "description": "480mmx750mm(dp) primary beam nested within slab depth, 480mmx500mm(dp) secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Glulam grade", "value": "GL24"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "5-15"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"}, 
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s15_b0_9x9_1_TTT_UK.png'),
            "tags": ["Commercial office", "Timber", "CLT", "Baseline", "Glulam"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s25_b0_9x9_1_TTT
        { 
            "id": "Frame_s25_b0_9x9_1_TTT",
            "name": "CLT timber 9x9", 
            "subtitle":"up to 25 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Timber",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - Glulam" , "value": 40.7 },
                { "name": "Timber - CLT" , "value": 59.3 },
                
            ],
            "components": [  
                { "name": "Columns" , "value": 13.7 },
                { "name": "Beams" , "value": 27.0 },
                { "name": "Slab" , "value": 59.3 },
            ],
            "carbon": [
                {"name": "Sequestration (not included)" , "value": -183.1 },
                {"name": "Material creation (A1-3)","value": 73.2 },
                {"name": "Transport (A4)", "value": 26.8 },
                {"name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 100.0,
            "units": 'kgCO2/m2(floor area)',
            "description": "480mmx750mm(dp) primary beam nested within slab depth, 480mmx500mm(dp) secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Glulam grade", "value": "GL24"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "15-25"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s25_b0_9x9_1_TTT_UK.png'),
            "tags": ["Commercial office", "Timber", "CLT", "Baseline", "Glulam"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s5_b0_9x9_1_STT_UK
        { 
            "id": "Frame_s5_b0_9x9_1_STT_UK",
            "name": "Steel Columns, Timber Slab & Beams 9x9",
            "subtitle":"up to 5 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - Glulam" , "value": 27.0 },
                { "name": "Timber - CLT" , "value": 59.3 },
                { "name": "Steel - UK Average" , "value": 17.0 }
            ],
            "components": [  
                { "name": "Columns" , "value": 17.0 },
                { "name": "Beams" , "value": 27.0 },
                { "name": "Slab" , "value": 59.3 },
            ],
            "carbon": [
                {"name": "Sequestration (not included)","value": -160.7 },
                {"name": "Material creation (A1-3)","value": 78.1 },
                {"name": "Transport (A4)", "value": 25.2 },
                {"name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 103.3,
            "units": 'kgCO2/m2(floor area)',
            "description": "200mm CLT slab, 480mmx750mm(dp) primary beam nested within slab depth, 480mmx500mm(dp) secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Glulam grade", "value": "GL24"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "1-5"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},
                
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s5_b0_9x9_1_STT_UK.png'),
            "tags": ["Commercial office", "Timber", "Steel", "CLT", "Baseline", "Glulam"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s15_b0_9x9_1_STT_UK
        { 
            "id": "Frame_s15_b0_9x9_1_STT_UK",
            "name": "Steel Columns, Timber Slab & Beams 9x9",
            "subtitle":"up to 15 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - Glulam" , "value": 27.0 },
                { "name": "Timber - CLT" , "value": 59.3 },
                { "name": "Steel - UK Average" , "value": 25.1 }
            ],
            "components": [  
                { "name": "Columns" , "value": 25.1 },
                { "name": "Beams" , "value": 27.0 },
                { "name": "Slabs" , "value": 59.3 },
            ],
            "carbon": [
                {"name": "Sequestration (not included)","value": -160.7 },
                {"name": "Material creation (A1-3)","value": 85.3 },
                {"name": "Transport (A4)", "value": 26.1 },
                {"name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 111.4,
            "units": 'kgCO2/m2(floor area)',
            "description": "200mm CLT slab, 480mmx750mm(dp) primary beam nested within slab depth, 480mmx500mm(dp) secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Glulam grade", "value": "GL24"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "5-15"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},
                
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s15_b0_9x9_1_STT_UK.png'),
            "tags": ["Commercial office", "Timber", "Steel", "CLT", "Baseline", "Glulam"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s25_b0_9x9_1_STT_UK
        { 
            "id": "Frame_s25_b0_9x9_1_STT_UK",
            "name": "Steel Columns, Timber Slab & Beams 9x9",
            "subtitle":"up to 25 storeys", 
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - Glulam" , "value": 27.0 },
                { "name": "Timber - CLT" , "value": 59.3 },
                { "name": "Steel - UK Average" , "value": 41.6 }
            ],
            "components": [  
                { "name": "Columns" , "value": 41.6 },
                { "name": "Beams" , "value": 27.0 },
                { "name": "Slabs" , "value": 59.3 },
            ],
            "carbon": [
                {"name": "Sequestration (not included)","value": -160.7 },
                {"name": "Material creation (A1-3)","value": 100.1 },
                {"name": "Transport (A4)", "value": 27.8 },
                {"name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 127.9,
            "units": 'kgCO2/m2(floor area)',
            "description": "200mm CLT slab, 480mmx750mm(dp) primary beam nested within slab depth, 480mmx500mm(dp) secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Glulam grade", "value": "GL24"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "15-25"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},
                
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s25_b0_9x9_1_STT_UK.png'),
            "tags": ["Commercial office", "Timber", "Steel", "CLT", "Baseline", "Glulam"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s5_b0_9x9_1_SSTT_UK
        { 
            "id": "Frame_s5_b0_9x9_1_SSTT_UK",
            "name": "Steel Columns & Primaries, Timber Slab & Secondaries 9x9",
            "subtitle":"up to 5 storeys", 
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - Glulam" , "value": 18.0 },
                { "name": "Timber - CLT" , "value": 59.3 },
                { "name": "Steel - UK Average" , "value": 34.7 }
            ],
            "components": [  
                { "name": "Columns" , "value": 17.0 },
                { "name": "Beams" , "value": 35.7 },
                { "name": "Slabs" , "value": 59.3 },
            ],
            "carbon": [
                {"name": "Sequestration (not included)","value": -146.0 },
                {"name": "Material creation (A1-3)","value": 87.2 },
                {"name": "Transport (A4)", "value": 24.8 },
                {"name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 112.0,
            "units": 'kgCO2/m2(floor area)',
            "description": "up to 5 storeys. 200mm CLT slab, 533x210x92 UB primary beam, 480mmx500mm(dp) secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Glulam grade", "value": "GL24"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "1-5"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},
                
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s5_b0_9x9_1_SSTT_UK.png'),
            "tags": ["Commercial office", "Timber", "Steel", "CLT", "Baseline", "Glulam"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s15_b0_9x9_1_SSTT_UK
        { 
            "id": "Frame_s15_b0_9x9_1_SSTT_UK",
            "name": "Steel Columns & Primaries, Timber Slab & Secondaries 9x9",
            "subtitle":"up to 15 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - Glulam" , "value": 18.0 },
                { "name": "Timber - CLT" , "value": 59.3 },
                { "name": "Steel - UK Average" , "value": 42.8 }
            ],
            "components": [  
                { "name": "Columns" , "value": 25.1 },
                { "name": "Beams" , "value": 35.7 },
                { "name": "Slabs" , "value": 59.3 },
            ],
            "carbon": [
                { "name": "Sequestration (not included)","value": -146.0 },
                { "name": "Material creation (A1-3)","value": 94.4 },
                { "name": "Transport (A4)", "value": 25.7 },
                { "name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 120.1,
            "units": 'kgCO2/m2(floor area)',
            "description": "200mm CLT slab, 533x210x92 UB primary beam, 480mmx500mm(dp) secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Glulam grade", "value": "GL24"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "5-15"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s15_b0_9x9_1_SSTT_UK.png'),
            "tags": ["Commercial office", "Timber", "Steel", "CLT", "Baseline", "Glulam"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },
        // Structures Frame - Frame_s25_b0_9x9_1_SSTT_UK
        { 
            "id": "Frame_s25_b0_9x9_1_SSTT_UK",
            "name": "Steel Columns & Primaries, Timber Slab & Secondaries 9x9", 
            "subtitle":"up to 25 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - Glulam" , "value": 27.0 },
                { "name": "Timber - CLT" , "value": 59.3 },
                { "name": "Steel - UK Average" , "value": 50.3 }
            ],
            "components": [  
                { "name": "Columns" , "value": 41.6 },
                { "name": "Beams" , "value": 35.7 },
                { "name": "Slabs" , "value": 59.3 },
            ],
            "carbon": [
                { "name": "Sequestration (not included)","value": -146.0 },
                {"name": "Material creation (A1-3)","value": 109.2 },
                {"name": "Transport (A4)", "value": 27.4 },
                {"name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 136.6,
            "units": 'kgCO2/m2(floor area)',
            "description": "200mm CLT slab, 533x210x92 UB primary beam, 480mmx500mm(dp) secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Glulam grade", "value": "GL24"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "15-25"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s25_b0_9x9_1_SSTT_UK.png'),
            "tags": ["Commercial office", "Timber", "Steel", "CLT", "Baseline", "Glulam"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s5_b0_9x9_1_SST_UK
        { 
            "id": "Frame_s5_b0_9x9_1_SST_UK",
            "name": "Steel frame, CLT timber slab 9x9",
            "subtitle":"up to 5 storeys", 
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - CLT" , "value": 59.3 },
                { "name": "Steel - UK Average" , "value": 57.8 },
            ],
            "components": [  
                { "name": "Columns" , "value": 17.0 },
                { "name": "Beams" , "value": 40.8 },
                { "name": "Slabs" , "value": 59.3 },
            ],
            "carbon": [
                { "name": "Sequestration (not included)","value": -116.4 },
                { "name": "Material creation (A1-3)","value": 94.3 },
                { "name": "Transport (A4)", "value": 22.8 },
                { "name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 117.1,
            "units": 'kgCO2/m2(floor area)',
            "description": "200mm CLT slab, 533x210x92 UB primary beam, 406x178x60 UB secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "1-5"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},          
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s5_b0_9x9_1_SST_UK.png'),
            "tags": ["Commercial office", "Timber", "Steel", "CLT", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },
        // Structures Frame - Frame_s15_b0_9x9_1_SST_UK
        { 
            "id": "Frame_s15_b0_9x9_1_SST_UK",
            "name": "Steel frame, CLT timber slab 9x9",
            "subtitle":"up to 15 storeys", 
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - CLT" , "value": 59.3 },
                { "name": "Steel - UK Average" , "value": 65.9 },
            ],
            "components": [  
                { "name": "Columns" , "value": 25.1 },
                { "name": "Beams" , "value": 40.8 },
                { "name": "Slabs" , "value": 59.3 },
            ],
            "carbon": [
                { "name": "Sequestration (not included)","value": -116.4 },
                { "name": "Material creation (A1-3)","value": 101.6 },
                { "name": "Transport (A4)", "value": 23.6 },
                { "name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 125.2,
            "units": 'kgCO2/m2(floor area)',
            "description": "200mm CLT slab, 533x210x92 UB primary beam, 406x178x60 UB secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "5-15"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},               
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s15_b0_9x9_1_SST_UK.png'),
            "tags": ["Commercial office", "Timber", "Steel", "CLT", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s25_b0_9x9_1_SST_UK
        { 
            "id": "Frame_s25_b0_9x9_1_SST_UK",
            "name": "Steel frame, CLT timber slab 9x9",
            "subtitle":"up to 25 storeys", 
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Timber - CLT" , "value": 59.3 },
                { "name": "Steel - UK Average" , "value": 65.9 },
            ],
            "components": [  
                { "name": "Columns" , "value": 41.6 },
                { "name": "Beams" , "value": 40.8 },
                { "name": "Slabs" , "value": 59.3 },
            ],
            "carbon": [
                { "name": "Sequestration (not included)","value": -116.4 },
                { "name": "Material creation (A1-3)","value": 116.3 },
                { "name": "Transport (A4)", "value": 25.4 },
                { "name": "Wastage (A5)", "value": 0 },
            ],
            "totalCarbon": 141.7,
            "units": 'kgCO2/m2(floor area)',
            "description": "200mm CLT slab, 533x210x92 UB primary beam, 406x178x60 UB secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Sequestration factor", "value": "-1.63kgCO2/kg"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "15-25"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, dynamics not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s25_b0_9x9_1_SST_UK.png'),
            "tags": ["Commercial office", "Timber", "Steel", "CLT", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s5_b0_9x9_1_SSC_UK
        { 
            "id": "Frame_s5_b0_9x9_1_SSC_UK",
            "name": "Steel frame, composite slab 9x9",
            "subtitle":"up to 5 storeys", 
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Composite deck" , "value": 42.5 },
                { "name": "Steel - section - world average" , "value": 65.9 },
                { "name": "Concrete C32/40 Standard" , "value": 40.9 },
                { "name": "Steel - reinformcement - UK average" , "value": 16.0 },
            ],
            "components": [  
                { "name": "Columns" , "value": 17.0 },
                { "name": "Beams" , "value": 48.9 },
                { "name": "Slabs" , "value": 99.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 153.0 },
                {"name": "Transport (A4)", "value": 10.0 },
                {"name": "Wastage (A5)", "value": 2.3 },
            ],
            "totalCarbon": 165.3,
            "units": 'kgCO2/m2(floor area)',
            "description": "130mm thick slab, 457x191x98 primary beams, 457x152x52 secondary beams",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Concrete grade", "value": "C32/40 Standard (Either 30-35% fly ash or 50-55% GGBS)"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "1-5"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness"},              
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s5_b0_9x9_1_SSC_UK.png'),
            "tags": ["Commercial office", "Composite deck", "Steel", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },
        // Structures Frame - Frame_s15_b0_9x9_1_SSC_UK
        { 
            "id": "Frame_s15_b0_9x9_1_SSC_UK",
            "name": "Steel frame, composite slab 9x9",
            "subtitle":"up to 15 storeys", 
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Composite deck" , "value": 42.5 },
                { "name": "Steel - section - world average" , "value": 98.8 },
                { "name": "Comcrete - C32/40 standard - 30-35% fly ash" , "value": 40.9 },
                { "name": "Steel - reinforcement - UK average" , "value": 16.0 },
            ],
            "components": [  
                { "name": "Columns" , "value": 49.8 },
                { "name": "Beams" , "value": 48.9 },
                { "name": "Slabs" , "value": 99.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 182.4 },
                {"name": "Transport (A4)", "value": 13.5 },
                {"name": "Wastage (A5)", "value": 2.3 },
            ],
            "totalCarbon": 198.2,
            "units": 'kgCO2/m2(floor area)',
            "description": "130mm thick slab, 457x191x98 primary beams, 457x152x52 secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Concrete grade", "value": "C32/40 Standard (Either 30-35% fly ash or 50-55% GGBS)"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "5-15"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s15_b0_9x9_1_SSC_UK.png'),
            "tags": ["Commercial office", "Composite deck", "Steel", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s25_b0_9x9_1_SSC_UK
        { 
            "id": "Frame_s25_b0_9x9_1_SSC_UK",
            "name": "Steel frame, composite slab 9x9",
            "subtitle":"up to 25 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Composite deck" , "value": 42.5 },
                { "name": "Steel - section - world average" , "value": 116.0 },
                { "name": "Comcrete - C32/40 standard - 30-35% fly ash" , "value": 40.9 },
                { "name": "Steel - reinforcement - UK average" , "value": 16.0 },
            ],
            "components": [  
                { "name": "Columns" , "value": 82.4 },
                { "name": "Beams" , "value": 71.5 },
                { "name": "Slabs" , "value": 83.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 197.9 },
                {"name": "Transport (A4)", "value": 15.3 },
                {"name": "Wastage (A5)", "value": 2.3 },
            ],
            "totalCarbon": 215.5,
            "units": 'kgCO2/m2(floor area)',
            "description": "130mm thick slab, 457x191x98 primary beams, 457x152x52 secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Concrete grade", "value": "C32/40 Standard (35% fly ash)"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "15-25"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s25_b0_9x9_1_SSC_UK.png'),
            "tags": ["Commercial office", "Composite deck", "Steel", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s5_b0_9x12_1_SSC_UK
        { 
            "id": "Frame_s5_b0_9x12_1_SSC_UK",
            "name": "Steel frame, composite slab 9x12",
            "subtitle":"up to 5 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Composite deck" , "value": 42.5 },
                { "name": "Steel - section - world average" , "value": 107.0 },
                { "name": "Comcrete - C32/40 standard - 30-35% fly ash" , "value": 40.9 },
                { "name": "Steel - reinforcement - UK average" , "value": 16.0 },
            ],
            "components": [  
                { "name": "Columns" , "value": 12.7 },
                { "name": "Beams" , "value": 94.3 },
                { "name": "Slabs" , "value": 99.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 198.6 },
                {"name": "Transport (A4)", "value": 5.6 },
                {"name": "Wastage (A5)", "value": 2.3 },
            ],
            "totalCarbon": 206.5,
            "units": 'kgCO2/m2(floor area)',
            "description": "130mm thick slab, 610x305x179 primary beams, 457x152x52 secondary beams. ",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Concrete grade", "value": "C32/40 Standard (35% fly ash)"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "0-5"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s5_b0_9x12_1_SSC_UK.png'),
            "tags": ["Commercial office", "Composite deck", "Steel", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s15_b0_9x12_1_SSC_UK
        { 
            "id": "Frame_s15_b0_9x12_1_SSC_UK",
            "name": "Steel frame, composite slab 9x12",
            "subtitle":"up to 15 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Composite deck" , "value": 42.5 },
                { "name": "Steel - section - world average" , "value": 131.7 },
                { "name": "Comcrete - C32/40 standard - 30-35% fly ash" , "value": 40.9 },
                { "name": "Steel - reinforcement - UK average" , "value": 16.0 },
            ],
            "components": [  
                { "name": "Columns" , "value": 37.4 },
                { "name": "Beams" , "value": 94.3 },
                { "name": "Slabs" , "value": 99.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 220.6 },
                {"name": "Transport (A4)", "value": 8.2 },
                {"name": "Wastage (A5)", "value": 2.3 },
            ],
            "totalCarbon": 231.1,
            "units": 'kgCO2/m2(floor area)',
            "description": "130mm thick slab, 610x305x179 primary beams, 457x152x52 secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Concrete grade", "value": "C32/40 Standard (35% fly ash)"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "5-15"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s15_b0_9x12_1_SSC_UK.png'),
            "tags": ["Commercial office", "Composite deck", "Steel", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s25_b0_9x12_1_SSC_UK
        { 
            "id": "Frame_s25_b0_9x12_1_SSC_UK",
            "name": "Steel frame, composite slab 9x12",
            "subtitle":"up to 25 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Steel",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019",
            "materials": [  
                { "name": "Composite deck" , "value": 42.5 },
                { "name": "Steel - section - world average" , "value": 144.7 },
                { "name": "Comcrete - C32/40 standard - 30-35% fly ash" , "value": 40.9 },
                { "name": "Steel - reinforcement - UK average" , "value": 16.0 },
            ],
            "components": [  
                { "name": "Columns" , "value": 50.3 },
                { "name": "Beams" , "value": 94.3 },
                { "name": "Slabs" , "value": 99.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 232.2 },
                {"name": "Transport (A4)", "value": 8.2 },
                {"name": "Wastage (A5)", "value": 2.3 },
            ],
            "totalCarbon": 242.7,
            "units": 'kgCO2/m2(floor area)',
            "description": "130mm thick slab, 610x305x179 primary beams, 457x152x52 secondary beams.",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Steel grade", "value": "S355"},
                { "name": "Concrete grade", "value": "C32/40 Standard (35% fly ash)"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "15-25"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s25_b0_9x12_1_SSC_UK.png'),
            "tags": ["Commercial office", "Composite deck", "Steel", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s5_b0_9x9_1_C0C_UK
        { 
            "id": "Frame_s5_b0_9x9_1_C0C_UK",
            "name": "Concrete flat slab 9x9",
            "subtitle":"up to 5 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - C32/40 Standard (30-35% fly ash or 50-55% GGBS" , "value": 98.0 },
                { "name": "Steel - Reinforcement UK" , "value": 40.8 },
            ],
            "components": [  
                { "name": "Columns" , "value": 4.4 },
                { "name": "Slabs" , "value": 134.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 127.6 },
                {"name": "Transport (A4)", "value": 5.8 },
                {"name": "Wastage (A5)", "value": 5.4 },
            ],
            "totalCarbon": 138.8,
            "units": 'kgCO2/m2(floor area)',
            "description": "",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "0-5"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s5_b0_9x9_1_C0C_UK.png'),
            "tags": ["Commercial office", "Concrete", "Flat slab", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s15_b0_9x9_1_C0C_UK
        { 
            "id": "Frame_s15_b0_9x9_1_C0C_UK",
            "name": "Concrete flat slab 9x9",
            "subtitle":"up to 15 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - C32/40 Standard (30-35% fly ash or 50-55% GGBS" , "value": 105.3 },
                { "name": "Steel - Reinforcement UK" , "value": 42.2 },
            ],
            "components": [  
                { "name": "Columns" , "value": 13.1 },
                { "name": "Slabs" , "value": 134.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 136.0 },
                {"name": "Transport (A4)", "value": 6.2 },
                {"name": "Wastage (A5)", "value": 5.4 },
            ],
            "totalCarbon": 147.5,
            "units": 'kgCO2/m2(floor area)',
            "description": "",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "5-15"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s15_b0_9x9_1_C0C_UK.png'),
            "tags": ["Commercial office", "Concrete", "Flat slab", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures Frame - Frame_s25_b0_9x9_1_C0C_UK
        { 
            "id": "Frame_s25_b0_9x9_1_C0C_UK",
            "name": "Concrete flat slab 9x9",
            "subtitle":"up to 25 storeys",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Frame",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - C32/40 Standard (30-35% fly ash or 50-55% GGBS" , "value": 114.2 },
                { "name": "Steel - Reinforcement UK" , "value": 43.8 },
            ],
            "components": [  
                { "name": "Columns" , "value": 23.6 },
                { "name": "Slabs" , "value": 134.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 146.0 },
                {"name": "Transport (A4)", "value": 6.5 },
                {"name": "Wastage (A5)", "value": 5.5 },
            ],
            "totalCarbon": 158.0,
            "units": 'kgCO2/m2(floor area)',
            "description": "",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Grid", "value": "9x9"},
                { "name": "Number of Storeys", "value": "15-25"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Frame_s25_b0_9x9_1_C0C_UK.png'),
            "tags": ["Commercial office", "Concrete", "Flat slab", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },



        // structural cores
        // Structures core - Core_s5_b0_0_1_C00_UK
        { 
            "id": "Core_s5_b0_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 5 storeys, no basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 1.4 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 0.7 },
                { "name": "Steel Reinforcement - UK average" , "value": 1.2 },
            ],
            "components": [  
                { "name": "Walls" , "value": 1.7 },
                { "name": "Piles & Pile Caps" , "value": 1.5 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 2.9 },
                {"name": "Transport (A4)", "value": 0.2 },
                {"name": "Wastage (A5)", "value": 0.1 },
            ],
            "totalCarbon": 3.2,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 5 storey building. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Pile cap depth", "value": "1.1m"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s5_b0_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s15_b0_0_1_C00_UK
        { 
            "id": "Core_s15_b0_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 15 storeys, no basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 5.1 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 0.7 },
                { "name": "Steel Reinforcement - UK average" , "value": 1.8 },
            ],
            "components": [  
                { "name": "Walls" , "value": 6.0 },
                { "name": "Piles & Pile Caps" , "value": 1.7 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 7.0 },
                {"name": "Transport (A4)", "value": 0.3 },
                {"name": "Wastage (A5)", "value": 0.3 },
            ],
            "totalCarbon": 7.7,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 15 storey building. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s15_b0_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s25_b0_0_1_C00_UK
        { 
            "id": "Core_s25_b0_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 25 storeys, no basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 9.6 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 1.0 },
                { "name": "Steel Reinforcement - UK average" , "value": 2.3 },
            ],
            "components": [  
                { "name": "Walls" , "value": 10.6 },
                { "name": "Piles & Pile Caps" , "value": 2.2 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 11.8 },
                {"name": "Transport (A4)", "value": 0.5 },
                {"name": "Wastage (A5)", "value": 0.5 },
            ],
            "totalCarbon": 12.8,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 25 storey building. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s25_b2_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s5_b2_0_1_C00_UK
        { 
            "id": "Core_s5_b2_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 5 storeys, 2 level basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 1.4 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 0.6 },
                { "name": "Steel Reinforcement - UK average" , "value": 1.0 },
            ],
            "components": [  
                { "name": "Walls" , "value": 1.7 },
                { "name": "Piles & Pile Caps" , "value": 1.3 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 2.7 },
                {"name": "Transport (A4)", "value": 0.2 },
                {"name": "Wastage (A5)", "value": 0.1 },
            ],
            "totalCarbon": 3.0,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 5 storey building with a 2 storey basement. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s5_b0_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s15_b2_0_1_C00_UK
        { 
            "id": "Core_s15_b2_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 15 storeys, 2 level basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 5.0 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 0.7 },
                { "name": "Steel Reinforcement - UK average" , "value": 1.7 },
            ],
            "components": [  
                { "name": "Walls" , "value": 5.9 },
                { "name": "Piles & Pile Caps" , "value": 1.6 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 6.9 },
                {"name": "Transport (A4)", "value": 0.3 },
                {"name": "Wastage (A5)", "value": 0.3 },
            ],
            "totalCarbon": 7.5,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 15 storey building with a 2 storey basement. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s15_b2_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s25_b2_0_1_C00_UK
        { 
            "id": "Core_s25_b2_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 15 storeys, 2 level basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 9.5 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 0.9 },
                { "name": "Steel Reinforcement - UK average" , "value": 2.2 },
            ],
            "components": [  
                { "name": "Walls" , "value": 10.5 },
                { "name": "Piles & Pile Caps" , "value": 2.1 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 11.6 },
                {"name": "Transport (A4)", "value": 0.5 },
                {"name": "Wastage (A5)", "value": 0.5 },
            ],
            "totalCarbon": 12.6,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 25 storey building with a 2 storey basement. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s25_b2_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s5_b1_0_1_C00_UK
        { 
            "id": "Core_s5_b1_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 5 storeys, 1 level basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 1.4 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 0.5 },
                { "name": "Steel Reinforcement - UK average" , "value": 1.0 },
            ],
            "components": [  
                { "name": "Walls" , "value": 1.7 },
                { "name": "Piles & Pile Caps" , "value": 1.3 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 2.7 },
                {"name": "Transport (A4)", "value": 0.15 },
                {"name": "Wastage (A5)", "value": 0.15 },
            ],
            "totalCarbon": 3.0,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 5 storey building with a 1 storey basement. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s5_b1_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s15_b1_0_1_C00_UK
        { 
            "id": "Core_s15_b1_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 15 storeys, 1 level basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 5.1 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 0.7 },
                { "name": "Steel Reinforcement - UK average" , "value": 1.8 },
            ],
            "components": [  
                { "name": "Walls" , "value": 5.9 },
                { "name": "Piles & Pile Caps" , "value": 1.7 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 7.0 },
                {"name": "Transport (A4)", "value": 0.3 },
                {"name": "Wastage (A5)", "value": 0.3 },
            ],
            "totalCarbon": 7.6,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 15 storey building with a 1 storey basement. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s15_b1_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s25_b1_0_1_C00_UK
        { 
            "id": "Core_s25_b1_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 25 storeys, 1 level basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 9.5 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 1.0 },
                { "name": "Steel Reinforcement - UK average" , "value": 2.2 },
            ],
            "components": [  
                { "name": "Walls" , "value": 10.6 },
                { "name": "Piles & Pile Caps" , "value": 2.1 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 11.7 },
                {"name": "Transport (A4)", "value": 0.5 },
                {"name": "Wastage (A5)", "value": 0.5 },
            ],
            "totalCarbon": 12.7,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 25 storey building with a 1 storey basement. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s25_b1_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s5_b4_0_1_C00_UK
        { 
            "id": "Core_s5_b4_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 5 storeys, 4 level basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 1.4 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 0.6 },
                { "name": "Steel Reinforcement - UK average" , "value": 1.0 },
            ],
            "components": [  
                { "name": "Walls" , "value": 1.6 },
                { "name": "Piles & Pile Caps" , "value": 1.3 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 2.7 },
                {"name": "Transport (A4)", "value": 0.1 },
                {"name": "Wastage (A5)", "value": 0.1 },
            ],
            "totalCarbon": 2.9,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 5 storey building with a 4 storey basement. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s5_b4_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s15_b4_0_1_C00_UK
        { 
            "id": "Core_s15_b4_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 15 storeys, 4 level basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 5.0 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 0.7 },
                { "name": "Steel Reinforcement - UK average" , "value": 1.7 },
            ],
            "components": [  
                { "name": "Walls" , "value": 5.7 },
                { "name": "Piles & Pile Caps" , "value": 1.6 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 6.7 },
                {"name": "Transport (A4)", "value": 0.3 },
                {"name": "Wastage (A5)", "value": 0.3 },
            ],
            "totalCarbon": 7.3,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 15 storey building with a 4 storey basement. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s15_b4_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures core - Core_s25_b4_0_1_C00_UK
        { 
            "id": "Core_s25_b4_0_1_C00_UK",
            "name": "Concrete core",
            "subtitle":"up to 25 storeys, 4 level basement",
            "type": "Buildings",
            "category": "Structure",
            "subCategory": "Core",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30% fly ash - C40/50" , "value": 9.4 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 0.9 },
                { "name": "Steel Reinforcement - UK average" , "value": 2.1 },
            ],
            "components": [  
                { "name": "Walls" , "value": 10.3 },
                { "name": "Piles & Pile Caps" , "value": 2.0 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 11.3 },
                {"name": "Transport (A4)", "value": 0.5 },
                {"name": "Wastage (A5)", "value": 0.5 },
            ],
            "totalCarbon": 12.3,
            "units": 'kgCO2/m2(totGIA)',
            "description": "core and associated piles for a 25 storey building with a 4 storey basement. Carbon value shown is averaged across total GIA of the building served",
            "designAssumptions": [
                { "name": "Storey height", "value": "4m"},
                { "name": "Analysis building Width", "value": "50m"},
                { "name": "Analysis building Depth", "value": "50m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Floor perimeter width for vertical load contribution", "value": "4m"},
                { "name": "Pile capacity", "value": "taken from test project in London"},
                { "name": "Wind load", "value": "1.5kN/m2"},
                { "name": "Span/depth ratio for wall depth", "value": "8m"},
                { "name": "Core strength", "value": "40Mpa Standard (35% fly ash)"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Omissions", "value": "connections not considered, fire, robustness, Openings, internal slab connection"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Core_s25_b4_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Core", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structural basements
        // Structures basement - Basement_s0_b0_9x12_1_CCC_UK
        { 
            "id": "Basement_s0_b0_9x12_1_CCC_UK",
            "name": "Ground Slab (no basement)",
            "subtitle":"Suspended slab, piled foundations, 9x12 grid",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30-35% fly ash - C32/40" , "value": 128.0 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 8.5 },
                { "name": "Steel Reinforcement - UK average" , "value": 70.9 },
            ],
            "components": [  
                { "name": "Floor" , "value": 185.4 },
                { "name": "Columns" , "value": 0 },
                { "name": "Piles & Pile Caps" , "value": 21.8 },
                { "name": "Transport of basement spoil" , "value": 6.6 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 189.9 },
                {"name": "Transport (A4)", "value": 15.6 },
                {"name": "Wastage (A5)", "value": 8.3 },
            ],
            "totalCarbon": 213.8,
            "units": 'kgCO2/m2(floor area)',
            "description": "No basement (Concrete ground slab only), with piled foundations (9m x 12m grid)",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Ground Slab thickness", "value": "400mm"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Pile diameter", "value": "600mm"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Pile cap depth", "value": "1.1m"},
                { "name": "Pile cap area", "value": "1.21m2"},
                { "name": "Omissions", "value": "connections not considered, robustness, water table not considered"},                
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basement_s0_b0_9x12_1_CCC_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },
        // Structures basement - Basement_s0_b0_9x9_1_00C_UK
        { 
            "id": "Basement_s0_b0_9x9_1_00C_UK",
            "name": "Ground Slab (no basement)",
            "subtitle":"Suspended slab, piled foundations, 9x9 grid",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30-35% fly ash - C32/40" , "value": 128.0 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 8.5 },
                { "name": "Steel Reinforcement - UK average" , "value": 70.9 },
            ],
            "components": [  
                { "name": "Floor" , "value": 185.4 },
                { "name": "Columns" , "value": 0.0 },
                { "name": "Piles & Pile Caps" , "value": 21.8 },
                { "name": "Transport of basement spoil" , "value": 6.6 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 189.9 },
                {"name": "Transport (A4)", "value": 15.6 },
                {"name": "Wastage (A5)", "value": 8.3 },
            ],
            "totalCarbon": 213.8,
            "units": 'kgCO2/m2(floor area)',
            "description": "No basement (Concrete ground slab only), with piled foundations (9m x 9m grid)",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "SGpund slab thickness", "value": "400mm"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Pile diameter", "value": "600mm"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Pile cap depth", "value": "1.1m"},
                { "name": "Pile cap area", "value": "1.21m2"},
                { "name": "Omissions", "value": "connections not considered, robustness, water table not considered"},                
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basement_s0_b0_9x9_1_00C_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures basement - Basement_s0_b1_9x12_1_CCC_UK
        { 
            "id": "Basement_s0_b1_9x12_1_CCC_UK",
            "name": "Basement Frame 9x12",
            "subtitle":"1 storey flat slab, piled foundations",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30-35% fly ash - C32/40" , "value": 125.0 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 5.5 },
                { "name": "Steel Reinforcement - UK average" , "value": 66.6 },
            ],
            "components": [  
                { "name": "Floor" , "value": 179.4 },
                { "name": "Columns" , "value": 3.8 },
                { "name": "Piles & Pile Caps" , "value": 14.3 },
                { "name": "Transport of basement spoil" , "value": 16.5 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 181.1 },
                {"name": "Transport (A4)", "value": 25.0 },
                {"name": "Wastage (A5)", "value": 7.9 },
            ],
            "totalCarbon": 214.0,
            "units": 'kgCO2/m2(floor area)',
            "description": "Single storey basement and piled foundations (9m x 12m grid). 250mm concrete slab, 800x400mm beams and 600mm square columns. ",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Ground slab thickness", "value": "400mm"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Frame construction", "value": "250mm slab + 800x400 beams"},
                { "name": "Column size", "value": "600mm"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Pile cap depth", "value": "1.1m"},
                { "name": "Pile cap area", "value": "1.21m2"},
                { "name": "Omissions", "value": "connections not considered, robustness, water table not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basement_s0_b1_9x12_1_CCC_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures basement - Basement_s0_b2_9x12_1_CCC_UK
        { 
            "id": "Basement_s0_b2_9x12_1_CCC_UK",
            "name": "Basement Frame 9x12",
            "subtitle":"2 storey flat slab, piled foundations",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30-35% fly ash - C32/40" , "value": 124.0 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 4.6 },
                { "name": "Steel Reinforcement - UK average" , "value": 65.2 },
            ],
            "components": [  
                { "name": "Floors" , "value": 177.5 },
                { "name": "Columns" , "value": 5.1 },
                { "name": "Piles & Pile Caps" , "value": 11.7 },
                { "name": "Transport of basement spoil" , "value": 19.8 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 178.2 },
                {"name": "Transport (A4)", "value": 28.2 },
                {"name": "Wastage (A5)", "value": 7.7 },
            ],
            "totalCarbon": 214.1,
            "units": 'kgCO2/m2(floor area)',
            "description": "Two-storey basement and piled foundations (9m x 12m grid). 250mm concrete slab, 800x400mm beams and 600mm square columns.",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Ground slab thickness", "value": "400mm"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Frame construction", "value": "250mm slab + 800x400 beams"},
                { "name": "Column size", "value": "600mm"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Pile cap depth", "value": "1.1m"},
                { "name": "Pile cap area", "value": "1.21m2"},
                { "name": "Omissions", "value": "connections not considered, robustness, water table not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basement_s0_b2_9x12_1_CCC_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures basement - Basement_s0_b4_9x12_1_CCC_UK
        { 
            "id": "Basement_s0_b4_9x12_1_CCC_UK",
            "name": "Basement Frame 9x12",
            "subtitle":"4 storey flat slab, piled foundations",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30-35% fly ash - C32/40" , "value": 124.0 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 3.8 },
                { "name": "Steel Reinforcement - UK average" , "value": 64.1 },
            ],
            "components": [  
                { "name": "Floors" , "value": 175.9 },
                { "name": "Columns" , "value": 6.1 },
                { "name": "Piles & Pile Caps" , "value": 9.7 },
                { "name": "Transport of basement spoil" , "value": 22.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 175.8 },
                {"name": "Transport (A4)", "value": 30.7 },
                {"name": "Wastage (A5)", "value": 7.6 },
            ],
            "totalCarbon": 214.1,
            "units": 'kgCO2/m2(floor area)',
            "description": "Four-storey basement and piled foundations (9m x 12m grid). 250mm concrete slab, 800x400mm beams and 600mm square columns.",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Ground slab thickness", "value": "400mm"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Frame construction", "value": "250mm slab + 800x400 beams"},
                { "name": "Column size", "value": "600mm"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Pile cap depth", "value": "1.1m"},
                { "name": "Pile cap area", "value": "1.21m2"},
                { "name": "Omissions", "value": "connections not considered, robustness, water table not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basement_s0_b4_9x12_1_CCC_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures basement - Basement_s0_b1_9x9_1_CCC_UK
        { 
            "id": "Basement_s0_b1_9x9_1_CCC_UK",
            "name": "Basement Frame 9x9",
            "subtitle":"1 storey flat slab, piled foundations",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30-35% fly ash - C32/40" , "value": 113.0 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 5.3 },
                { "name": "Steel Reinforcement - UK average" , "value": 60.6 },
            ],
            "components": [  
                { "name": "Floors" , "value": 160.7 },
                { "name": "Columns" , "value": 4.9 },
                { "name": "Piles & Pile Caps" , "value": 13.5 },
                { "name": "Transport of basement spoil" , "value": 16.5 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 164.2 },
                {"name": "Transport (A4)", "value": 24.2 },
                {"name": "Wastage (A5)", "value": 7.1 },
            ],
            "totalCarbon": 195.6,
            "units": 'kgCO2/m2(floor area)',
            "description": "Single storey basement and piled foundations (9m x 9m grid). 200mm concrete slab, 600x350mm beams and 600mm square columns.",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Ground slab thickness", "value": "400mm"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Frame construction", "value": "250mm slab + 800x400 beams"},
                { "name": "Column size", "value": "600mm"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Pile cap depth", "value": "1.1m"},
                { "name": "Pile cap area", "value": "1.21m2"},
                { "name": "Omissions", "value": "connections not considered, robustness, water table not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basement_s0_b1_9x9_1_CCC_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },
        
        // Structures basement - Basement_s0_b2_9x9_1_CCC_UK
        { 
            "id": "Basement_s0_b2_9x9_1_CCC_UK",
            "name": "Basement Frame 9x9",
            "subtitle":"2 storey flat slab, piled foundations",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30-35% fly ash - C32/40" , "value": 108.0 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 4.3 },
                { "name": "Steel Reinforcement - UK average" , "value": 57.4 },
            ],
            "components": [  
                { "name": "Floors" , "value": 152.4 },
                { "name": "Columns" , "value": 6.5 },
                { "name": "Piles & Pile Caps" , "value": 11.1 },
                { "name": "Transport of basement spoil" , "value": 19.8 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 155.9 },
                {"name": "Transport (A4)", "value": 27.1 },
                {"name": "Wastage (A5)", "value": 6.8 },
            ],
            "totalCarbon": 189.8,
            "units": 'kgCO2/m2(floor area)',
            "description": "Two-storey basement and piled foundations (9m x 9m grid). 200mm concrete slab, 800x400mm beams and 600mm square columns.",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Ground slab thickness", "value": "400mm"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Frame construction", "value": "250mm slab + 800x400 beams"},
                { "name": "Column size", "value": "600mm"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Pile cap depth", "value": "1.1m"},
                { "name": "Pile cap area", "value": "1.21m2"},
                { "name": "Omissions", "value": "connections not considered, robustness, water table not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basement_s0_b2_9x9_1_CCC_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures basement - Basement_s0_b4_9x9_1_CCC_UK
        { 
            "id": "Basement_s0_b4_9x9_1_CCC_UK",
            "name": "Basement frame 9x9",
            "subtitle":"4 storey flat slab, piled foundations",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 30-35% fly ash - C32/40" , "value": 104.0 },
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 3.6 },
                { "name": "Steel Reinforcement - UK average" , "value": 54.9 },
            ],
            "components": [  
                { "name": "Floors" , "value": 145.8 },
                { "name": "Columns" , "value": 7.8 },
                { "name": "Piles & Pile Caps" , "value": 9.3 },
                { "name": "Transport of basement spoil" , "value": 22.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 149.4 },
                {"name": "Transport (A4)", "value": 29.4 },
                {"name": "Wastage (A5)", "value": 6.5 },
            ],
            "totalCarbon": 185.3,
            "units": 'kgCO2/m2(floor area)',
            "description": "Four-storey basement and piled foundations (9m x 12m grid). 250mm concrete slab, 800x400mm beams and 600mm square columns.",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Live load", "value": "3.5kPa"},
                { "name": "SDL", "value": "0.85kPa"},
                { "name": "Ground slab thickness", "value": "400mm"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Frame construction", "value": "250mm slab + 800x400 beams"},
                { "name": "Column size", "value": "600mm"},
                { "name": "Pile grade", "value": "32Mpa Standard (70% GGBS)"},
                { "name": "Pile cap depth", "value": "1.1m"},
                { "name": "Pile cap area", "value": "1.21m2"},
                { "name": "Omissions", "value": "connections not considered, robustness, water table not considered"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basement_s0_b4_9x9_1_CCC_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures basement - Basementwall_s0_b1_0_1_C00_UK
        { 
            "id": "Basementwall_s0_b1_0_1_C00_UK",
            "name": "Secant pile wall and lining wall",
            "subtitle":"For use in 1 storey basements",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 1098.4 },
                { "name": "Steel Reinforcement - UK average" , "value": 749.9 },
            ],
            "components": [  
                { "name": "Walls" , "value": 1848.2 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 1656.7 },
                {"name": "Transport (A4)", "value": 116.5 },
                {"name": "Wastage (A5)", "value": 75.0 },
            ],
            "totalCarbon": 1848.2,
            "units": 'kgCO2/m(wall)',
            "description": "Secant pile wall and lining wall for use around the perimeter of a basement. Units in carbon per linear meter of wall",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Lining wall thickness", "value": "200mm"},
                { "name": "Toe depth of secant pile wall", "value": "6.4m below slab"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Pile diameter", "value": "600mm"},
                { "name": "Omissions", "value": "connections not considered, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basementwall_s0_b1_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline", "Secant pile wall"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures basement - Basementwall_s0_b2_0_1_C00_UK
        { 
            "id": "Basementwall_s0_b2_0_1_C00_UK",
            "name": "Secant pile wall and lining wall",
            "subtitle":"For use in 2 storey basements",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 1537.7 },
                { "name": "Steel Reinforcement - UK average" , "value": 1090.7 },
            ],
            "components": [  
                { "name": "Walls" , "value": 2628.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 2357.1 },
                {"name": "Transport (A4)", "value": 164.7 },
                {"name": "Wastage (A5)", "value": 106.6 },
            ],
            "totalCarbon": 2628.4,
            "units": 'kgCO2/m(wall)',
            "description": "Secant pile wall and lining wall for use around the perimeter of a basement. Units in carbon per linear meter of wall",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Lining wall thickness", "value": "200mm"},
                { "name": "Toe depth of secant pile wall", "value": "6.4m below slab"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Pile diameter", "value": "600mm"},
                { "name": "Omissions", "value": "connections not considered, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basementwall_s0_b2_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline", "Secant pile wall"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // Structures basement - Basementwall_s0_b4_0_1_C00_UK
        { 
            "id": "Basementwall_s0_b4_0_1_C00_UK",
            "name": "Secant pile wall and lining wall",
            "type": "Buildings",
            "subtitle":"For use in 4 storey basements",
            "category": "Structure",
            "subCategory" : "Substructure",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 2416.4 },
                { "name": "Steel Reinforcement - UK average" , "value": 1772.4 },
            ],
            "components": [  
                { "name": "Walls" , "value": 4188.8 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 3757.9 },
                {"name": "Transport (A4)", "value": 261.2 },
                {"name": "Wastage (A5)", "value": 169.7 },
            ],
            "totalCarbon": 4188.8,
            "units": 'kgCO2/m(wall)',
            "description": "Secant pile wall and lining wall for use around the perimeter of a basement. Units in carbon per linear meter of wall",
            "designAssumptions": [
                { "name": "Storey height", "value": "3.2m"},
                { "name": "Lining wall thickness", "value": "200mm"},
                { "name": "Toe depth of secant pile wall", "value": "6.4m below slab"},
                { "name": "Frame grade", "value": "32MPa, 30% fly ash"},
                { "name": "Pile diameter", "value": "600mm"},
                { "name": "Omissions", "value": "connections not considered, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/Basementwall_s0_b4_0_1_C00_UK.png'),
            "tags": ["Commercial office", "Concrete", "Basement", "Baseline", "Secant pile wall"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // structural foundations
        // FrameFoundations_s0_b0_0_1_STSTT_UK
        { 
            "id": "FrameFoundations_s0_b0_0_1_STSTT_UK",
            "name": "Frame Foundation",
            "subtitle":"Concrete Superstructure",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Foundation",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 7.4 },
                { "name": "Steel Reinforcement - UK average" , "value": 6.4 },
            ],
            "components": [  
                { "name": "Pile Foundations" , "value": 13.8 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 12.4 },
                {"name": "Transport (A4)", "value": 0.8 },
                {"name": "Wastage (A5)", "value": 0.6 },
            ],
            "totalCarbon": 13.8,
            "units": 'kgCO2/m2(totGIA)',
            "description": "Foundation for use with concrete frame superstructure",
            "designAssumptions": [
                { "name": "Live Load", "value": "3.5kPa"},
                { "name": "TSDL", "value": "0.85kPa"},
                { "name": "Concrete grade", "value": "C32/40MPa, 70% Blast Furnace Slag"},
                { "name": "Omissions", "value": "connections not considered, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/FrameFoundations_s0_b0_0_1_STSTT_UK.png'),
            "tags": ["Commercial office", "Concrete", "Foundation", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // FrameFoundations_s0_b0_0_1_C0C_UK
        { 
            "id": "FrameFoundations_s0_b0_0_1_C0C_UK",
            "name": "Frame Foundation",
            "subtitle":"Timber Superstructure",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Foundation",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 3.7 },
                { "name": "Steel Reinforcement - UK average" , "value": 3.2 },
            ],
            "components": [  
                { "name": "Pile Foundations" , "value": 6.9 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 6.2 },
                {"name": "Transport (A4)", "value": 0.4 },
                {"name": "Wastage (A5)", "value": 0.3 },
            ],
            "totalCarbon": 6.9,
            "units": 'kgCO2/m2(totGIA)',
            "description": "Foundation for use with timber frame superstructure",
            "designAssumptions": [
                { "name": "Live Load", "value": "3.5kPa"},
                { "name": "TSDL", "value": "0.85kPa"},
                { "name": "Concrete grade", "value": "C32/40MPa, 70% Blast Furnace Slag"},
                { "name": "Omissions", "value": "connections not considered, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/FrameFoundations_s0_b0_0_1_C0C_UK.png'),
            "tags": ["Commercial office", "Concrete", "Foundation", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        },

        // FrameFoundations_s0_b0_0_1_SSC_UK
        { 
            "id": "FrameFoundations_s0_b0_0_1_SSC_UK",
            "name": "Frame Foundation",
            "subtitle":"Steel Superstructure",
            "type": "Buildings",
            "category": "Structure",
            "subCategory" : "Foundation",
            "sector": "Commercial",
            "scope": "A1-5 Carbon",
            "primarymaterial": "Concrete",
            "region": "UK",
            "carbonDatabase": "ICEv3b 2019 & PECCv3.6 2020",
            "materials": [  
                { "name": "Concrete - 70% BBFS - C32/40" , "value": 5.6 },
                { "name": "Steel Reinforcement - UK average" , "value": 4.8 },
            ],
            "components": [  
                { "name": "Pile Foundations" , "value": 10.4 },
            ],
            "carbon": [
                {"name": "Material creation (A1-3)","value": 9.3 },
                {"name": "Transport (A4)", "value": 0.6 },
                {"name": "Wastage (A5)", "value": 0.4 },
            ],
            "totalCarbon": 10.4,
            "units": 'kgCO2/m2(totGIA)',
            "description": "Foundation for use with steel frame superstructure",
            "designAssumptions": [
                { "name": "Live Load", "value": "3.5kPa"},
                { "name": "TSDL", "value": "0.85kPa"},
                { "name": "Concrete grade", "value": "C32/40MPa, 70% Blast Furnace Slag"},
                { "name": "Omissions", "value": "connections not considered, robustness"},
            ],
            "references": [
                "Arup Concept Design Guide 2017",
                "BCO Guide 2019",
                "RICS Whole Life Carbon Assessment for the Built Environment 2017",
                "ICE Database v3.0b 2019",
                "Arup PECC 2020"
            ],
            "src":require('@/store/typ-images/FrameFoundations_s0_b0_0_1_SSC_UK.png'),
            "tags": ["Commercial office", "Concrete", "Foundation", "Baseline"],
            "dialog": false,
            "guidanceType": 'baseline',
            "authors":['Tara Clinton', 'Grace Di Benedetto', 'Tom Styles']
        }



        
        // MECHANICAL CARDS



        // TEMPLATE TO USE
        // { 
        //     "id": "",
        //     "name": "", 
        //     "category": "",
        //     "subCategory": "",
        //     "sector": "",
        //     "scope": "",
        //     "primarymaterial": "",
        //     "region": "",
        //     "carbonDatabase": "ICEv3b 2019",
        //     "materials": [  
        //         { "name": "" , "value": 0 },
        //         { "name": "" , "value": 0 },
        //     ],
        //     "components": [  
        //         { "name": "" , "value": 0 },
        //         { "name": "" , "value": 0 },
        //     ],
        //     "carbon": [
        //         {"name": "Material creation (A1-3)","value": 0 },
        //         {"name": "Transport (A4)", "value": 0 },
        //         {"name": "Wastage (A5)", "value": 0 },
        //     ],
        //     "totalCarbon": 0,
        //     "units": 'kgCO2/m2(floor area)',
        //     "description": "",
        //     "designAssumptions": [
        //         { "name": "", "value": ""},
        //         { "name": "", "value": ""},
        //         { "name": "", "value": ""},
        //         { "name": "", "value": ""},
        //         { "name": "", "value": ""},
        //         { "name": "", "value": ""},
                
        //     ],
        //     "references": [],
        //     "src":require(''),
        //     "tags": [""],
        //     "dialog": false,
        //     "guidanceType": 'baseline'
        // },

        // AUSTRALIAN CARDS (TO BE UPDATED)
        // { 
        //     "id": "aus-1",
        //     "name": "PT Flat Slab (9x9) - AUS", 
        //     "category": "Structure",
        //     "subCategory": "Frame",
        //     "sector": "Commercial",
        //     "scope": "A1-5 Carbon",
        //     "primarymaterial": "Concrete",
        //     "region": "Australia",
        //     "carbonDatabase": "EPiC 2019",
        //     "materials": [  
        //         { "name": "Concrete 40Mpa" , "totalcarbon": 133.5 },
        //         { "name": "Concrete 50Mpa" , "totalcarbon": 12.1 },
        //         { "name": "Steel reinforcement" , "totalcarbon": 79.5 },
        //     ],
        //     "carbon": [
        //         {"name": "Material creation (A1-3)" , "value": 209.8},
        //         {"name": "Transport (A4)" , "value": 3.8},
        //         {"name": "Wastage (A5)" , "value": 11.4},
        //         {"name": "Site emissions (A5)", "value": 0.0},
        //     ],
        //     "totalCarbon": 255.1,
        //     "units": 'kgCO2/m2(floor area)',
        //     "description": "Post-tensioned concrete structure typically found in commercial offices. 250mm slab, reo - 0.8%, PT strand - 0.45%, column - 1.5%",
        //     "designAssumptions": [
        //         { "name": "Grid", "value": "9x9"},
        //         { "name": "Slab loading", "value": "3.5 kPa"},
        //         { "name": "Slab thickness", "value": "250mm"},
        //         { "name": "Slab reinforcement", "value": "0.8%"},
        //         { "name": "PT strand", "value": "0.45%"},
        //         { "name": "Column Size", "value": "200x200"},
        //         { "name": "Column reinforcement", "value": "1.5%"},
        //         { "name": "F2F height", "value": "3.8m"},
        //     ],
        //     "references": [],
        //     "src":require('@/store/typ-images/aus-commercial-9x9pt-flatslab.png'),
        //     "tags":["baseline", "concrete frame", "commercial office", "9x9"],
        //     "dialog": false,
        //     "guidanceType": 'baseline'
        // },
        // { 
        //     "id": "aus-2",
        //     "name": "PT Slab & Band Beam (12x9) - AUS", 
        //     "category": "Structure",
        //     "subCategory": "Frame",
        //     "sector": "Commercial",
        //     "scope": "A1-5 Carbon",
        //     "primarymaterial": "Concrete",
        //     "region": "Australia",
        //     "carbonDatabase": "EPiC 2019",
        //     "materials": [  
        //         { "name": "Concrete 40Mpa" , "totalcarbon": 165.6 },
        //         { "name": "Concrete 50Mpa" , "totalcarbon": 16.5 },
        //         { "name": "Steel reinforcement" , "totalcarbon": 91.0 },
        //     ],
        //     "carbon": [
        //         {"name": "Material creation (A1-3)","value": 254.8},
        //         {"name": "Transport (A4)" , "value": 4.7 },
        //         {"name": "Wastage (A5)" , "value": 13.9},
        //         {"name": "Site emissions (A5)" , "value": 0.0},
        //     ],
        //     "totalCarbon": 273.4,
        //     "units": 'kgCO2/m2(floor area)',
        //     "description": "Post-tensioned concrete structure typically found in commercial offices. 200mm one-way slab, 450mm band beams, slab rates - 0.7%, PT strand - 0.4%, beam rates - 0.7%, column reo rate - 1.5%",
        //     "designAssumptions": [
        //         { "name": "Grid", "value": "12x9"},
        //         { "name": "Slab loading", "value": "3.5 kPa"},
        //         { "name": "Slab thickness", "value": "200mm"},
        //         { "name": "Slab reinforcement", "value": "0.7%"},
        //         { "name": "PT strand", "value": "0.4%"},
        //         { "name": "Band beam depth", "value": "450mm"},
        //         { "name": "Band beam reinforcement", "value": "0.7%"},
        //         { "name": "Column size", "value": "200x200"},
        //         { "name": "Column reinforcement", "value": "1.5%"},
        //         { "name": "F2F height", "value": "3.8m"},
        //     ],
        //     "references": [],
        //     "src":require('@/store/typ-images/aus-commercial-12x9pt-beamslab.png'),
        //     "tags": ["baseline", "concrete frame", "commercial office","12x9"],
        //     "dialog": false,
        //     "guidanceType": 'baseline'
        // },
        // { 
        //     "id": "aus-3",
        //     "name": "Glulam Beam, CLT Slab (9x6) - AUS", 
        //     "category": "Structure",
        //     "subCategory": "Frame",
        //     "sector": "Commercial",
        //     "scope": "A1-5 Carbon",
        //     "primarymaterial": "Timber",
        //     "region": "Australia",
        //     "carbonDatabase": "EPiC 2019",
        //     "materials": [  
        //         { "name": "Timber - CLT" , "totalcarbon": 165.6 },
        //         { "name": "Timber - Glulam" , "totalcarbon": 16.5 },
                
        //     ],
        //     "carbon": [
        //         {"name": "Material creation (A1-3)","value": 157.9},
        //         {"name": "Transport (A4)", "value": 11.4},
        //         {"name": "Wastage (A5)", "value": 19.0 },
        //         {"name": "Site emissions(A5)", "value": 0.0},
        //     ],
        //     "totalCarbon": 188.4,
        //     "units": 'kgCO2/m2(floor area)',
        //     "description": "Timber CLT and Glulam structure for use in commercial offices. Not including sequestration. 660x520 Glulam primary beams, 420x260 glulam secondary beams, 240mm CLT slab",
        //     "designAssumptions": [
        //         { "name": "Grid", "value": "9x6"},
        //         { "name": "Slab loading", "value": "3.5 kPa"},
        //         { "name": "Slab thickness", "value": "240mm"},
        //         { "name": "Primary beam size", "value": "660x520"},
        //         { "name": "Secondary beam size", "value": "420x260"},
        //         { "name": "Column size", "value": "200x200"},
        //         { "name": "F2F height", "value": "3.8m"},
        //     ],
        //     "references": [],
        //     "src":require('@/store/typ-images/aus-commercial-9x6-timber.png'),
        //     "tags":["baseline", "timber frame", "commercial office", "9x6"],
        //     "dialog": false,
        //     "guidanceType": 'good practice'
        // },
        // { 
        //     "id": "aus-4",
        //     "name": "Typical Bondek (9x9) - AUS", 
        //     "category": "Structure",
        //     "subCategory": "Frame",
        //     "sector": "Commercial",
        //     "scope": "A1-5 Carbon",
        //     "primarymaterial": "Steel",
        //     "region": "Australia",
        //     "carbonDatabase": "EPiC 2019",
        //     "materials": [  
        //         { "name": "Steel - hot rolled structural" , "totalcarbon": 172.5 },
        //         { "name": "Concrete 40MPa" , "totalcarbon": 72.3 },
        //         { "name": "Steel reinforcement" , "totalcarbon": 29.6 },
        //         { "name": "Steel corrugated colorbond" , "totalcarbon": 12.8 },
        //     ],
        //     "carbon": [
        //         {"name":"Material creation (A1-3)","value": 268.9},
        //         {"name":"Transport (A4)" , "value": 3.8},
        //         {"name":"Wastage (A5)" , "value": 14.5},
        //         {"name":"Site emissions (A5)" , "value": 0.0},
        //     ],
        //     "totalCarbon": 287.2,
        //     "units": 'kgCO2/m2(floor area)',
        //     "description": "Steel frame and Bondek slab. Used in commercial projects. 610UB primary, 350UB secondary, 130mm slab, 1% reinforcement, 1mm bondek. Loading: 4kPa SFL-1kPa",
        //     "designAssumptions": [
        //         { "name": "Grid", "value": "9x9"},
        //         { "name": "Slab loading", "value": "4.0 kPa"},
        //         { "name": "Slab thickness", "value": "130mm"},
        //         { "name": "Slab reinforcement", "value": "1.0%"},
        //         { "name": "Primary beam size", "value": "610UB"},
        //         { "name": "Secondary beam size", "value": "350UB"},
        //         { "name": "Column size", "value": "200x200"},
        //         { "name": "F2F height", "value": "3.8m"},
        //     ],
        //     "references": [],
        //     "src":require('@/store/typ-images/aus-commercial-9x9-bondek.png'),
        //     "tags":["baseline", "steel frame", "commercial office", "9x9"],
        //     "dialog": false,
        //     "guidanceType": 'worst case'
        // },
        // { 
        //     "id": "uk-1",
        //     "name": "PT Slab & Band Beam (12x9) - UK", 
        //     "category": "Structure",
        //     "subCategory": "Frame",
        //     "sector": "Commercial",
        //     "scope": "A1-5 Carbon",
        //     "primarymaterial": "Concrete",
        //     "region": "UK",
        //     "carbonDatabase": "ICEv3b 2019",
        //     "materials": [  
        //         { "name": "Concrete - 40/50 MPa" , "totalcarbon": 137.6 },
        //         { "name": "Steel - Rebar" , "totalcarbon": 64.6 },
                
        //     ],
        //     "carbon": [
        //         {"name": "Material creation (A1-3)","value": 188.6},
        //         {"name": "Transport (A4)", "value": 4.7},
        //         {"name": "Wastage (A5)", "value": 8.9},
        //         {"name": "Site emissions (A5)", "value": 0.0},
        //     ],
        //     "totalCarbon": 202.2,
        //     "units": 'kgCO2/m2(floor area)',
        //     "description": "Post-tensioned concrete structure typically found in commercial offices. 200mm one-way slab, 450mm band beams, slab rates - 0.7%, PT strand - 0.4%, beam rates - 0.7%, column reo rate - 1.5%",
        //     "designAssumptions": [
        //         { "name": "Grid", "value": "12x9"},
        //         { "name": "Slab loading", "value": "3.5 kPa"},
        //         { "name": "Slab thickness", "value": "200mm"},
        //         { "name": "Slab reinforcement", "value": "0.7%"},
        //         { "name": "PT strand", "value": "0.45%"},
        //         { "name": "Band beam depth", "value": "450mm"},
        //         { "name": "Band beam reinforcement", "value": "0.7%"},
        //         { "name": "Secondary beam size", "value": "350UB"},
        //         { "name": "Column size", "value": "200x200"},
        //         { "name": "Column reinforcement", "value": "1.5%"},
        //         { "name": "F2F height", "value": "3.8m"},
        //     ],
        //     "references": [],
        //     "src":require('@/store/typ-images/uk-commercial-12x9pt-beamslab.png'),
        //     "tags": ["baseline", "concrete frame", "commercial office", "12x9"],
        //     "dialog": false,
        //     "guidanceType": 'baseline'
        // },
    ];

export default Typologies;

